import { h } from 'preact'
import { useState } from 'preact/hooks'
import { i18n } from 'i18n/i18n'
import { Calculation } from 'models/exchange-transfer-calculate'

interface BuyTooltipProps {
  exchangeData: Calculation
}
const BuyTooltip = ({ exchangeData }: BuyTooltipProps) => {
  const [isVisible, setIsVisible] = useState(false)
  const feePercent = Number(exchangeData.fee_percent) || 0

  return (
    <span
      className="double-input-calculator__sign-holder"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {isVisible && (
        <span className="double-input-calculator__answer-info">
          {i18n('rateCalculator.counterInputTooltip', { commission: feePercent })}
          <span className="double-input-calculator__triangle" />
        </span>
      )}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="help-tip-svg"
        viewBox="0 0 512 512"
        height="14"
        width="14"
      >
        <path
          fill="currentColor"
          d="M256 8a248 248 0 1 0 0 496 248 248 0 0 0 0-496zm0 448a200 200 0 1 1 0-400 200 200 0 0 1 0 400zm107-255c0 67-72 68-72 93v6c0 7-6 12-12 12h-46c-6 0-12-5-12-12v-9c0-35 27-50 48-61 17-10 28-17 28-30 0-17-22-28-40-28-23 0-34 11-49 30-4 5-11 6-16 2l-28-21c-5-4-6-12-3-17 24-35 54-54 101-54 49 0 101 38 101 89zm-65 167a42 42 0 1 1-84 0 42 42 0 0 1 84 0z"
        />
      </svg>
    </span>
  )
}

export default BuyTooltip
